module.exports = __webpack_public_path__ + "static/img/face2.894d686.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/3x/face2.png
// module id = Q9PK
// module chunks = 1